import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import Error from "../../common/Error/Error";
import styles from './AdminList.css';
import Admin from '../Admin/Admin';

const AdminList = (props) => {
    const { loading, admins, title } = props;

    let content;

    if (loading) {
        content = <Loading paper={false} />;
    } else if (admins.length === 0) {
        content =
            <Error
                title="No data"
                subtitle="Add some admins"
            />
    }  else {
        content = admins.map(function(admin, index) {
            return <div key={admin.id}>
                <Admin
                    admin={admin}
                    user={props.user}
                    handleRemoveAdmin={props.handleRemoveAdmin}
                />
                {index !== (admins.length - 1) &&  <Divider inset={true}/>}
            </div>
        })
    }

    return (
        <Paper>
            <List>
                <Subheader style={styles.subheader}>{title}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

AdminList.propTypes = {
    user: PropTypes.object.isRequired,
    admins: PropTypes.arrayOf(PropTypes.object).isRequired,
    loading: PropTypes.bool.isRequired,
    title: PropTypes.string
};

export default AdminList;



// WEBPACK FOOTER //
// src/components/admin/AdminList/AdminList.js